export const CongratulationsIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="71"
			height="113"
			viewBox="0 0 71 113"
			fill="none"
		>
			<g clipPath="url(#clip0_16681_61107)">
				<path
					d="M9.94922 30.9141C10.2004 31.9739 10.5164 33.1152 11.3915 33.7511C12.1532 34.2973 13.1579 34.3136 14.0735 34.5256C15.7913 34.9169 17.4362 36.3272 17.4524 38.1045C17.4524 39.0746 16.9986 40.1018 17.3957 40.9904C17.8332 41.9524 19.0405 42.2296 20.0858 42.3437"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M37.4879 44.1145C36.6533 43.7069 36.1266 42.7775 36.0699 41.84C36.0131 40.9025 36.3778 39.9731 36.9612 39.2394C37.7066 38.2937 38.8734 37.2747 38.444 36.1497C38.0794 35.1958 36.8315 35.0246 35.9969 34.4295C35.0165 33.7366 34.6519 32.2854 35.1786 31.2012C35.5027 30.5327 36.1023 30.0354 36.4183 29.3587C36.7343 28.6902 36.5803 27.6712 35.8592 27.5"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M23.1055 51.9922C23.5187 52.6118 23.9563 53.2069 24.4262 53.7857C24.8233 54.2749 25.2446 54.7558 25.7794 55.0819C26.7517 55.6852 27.959 55.7097 29.1096 55.726"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M29.2571 46.9846C27.831 44.5552 27.045 41.7507 26.9883 38.9219"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M43.6797 13.7344C45.5595 14.8268 47.0829 16.5388 47.958 18.5443"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M62.6172 42.4418C62.682 39.8493 63.4194 37.2732 64.7239 35.0312"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M59.0733 6.78906C59.0085 9.54456 59.997 12.3082 61.7958 14.3789"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.10938 34.1977C2.09792 33.8308 3.2242 34.3037 4.00207 35.0129C4.77994 35.7222 5.32283 36.6679 5.97915 37.4913"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M22.4766 16.5781C24.0566 17.2222 25.426 18.388 26.3011 19.8635"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M55.8838 21.875C55.6083 22.6087 56.0135 23.5299 56.7346 23.8234C57.1235 23.9783 57.5773 23.9702 57.9257 24.1984C58.4848 24.5653 58.5496 25.3642 58.4038 26.0164C58.2579 26.6686 57.95 27.2963 57.9662 27.9648C57.9824 28.5599 58.2903 29.1469 58.7603 29.5056C59.2141 29.848 59.8137 30.0111 60.1297 30.4758C60.5267 31.0627 60.1864 31.9921 59.5139 32.1877"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M53.7211 10.1076C53.0891 9.7081 52.8055 8.89286 52.8784 8.14284C52.9513 7.39283 53.3321 6.70803 53.7859 6.1129C54.3288 5.40365 55.0418 4.61287 54.8231 3.74056C54.6367 2.98239 53.7535 2.38727 53.948 1.62095C54.0452 1.22963 54.4098 0.960607 54.5962 0.59375"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M66.8607 25.7197C66.6095 25.0838 66.3745 24.3011 66.7877 23.7549C66.9498 23.5348 67.1929 23.3962 67.4197 23.2413C68.1247 22.744 68.6919 21.8799 68.4812 21.032C68.2624 20.1923 67.3468 19.6461 67.2253 18.7901C67.0875 17.7955 68.0437 17.0374 68.8945 16.5156"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M47.3086 40.3125C48.0216 40.4837 48.3863 41.3152 48.362 42.049C48.3376 42.7827 48.0378 43.4756 47.8758 44.193C47.7948 44.5517 47.7542 44.9186 47.8353 45.2773C47.973 45.8969 48.4754 46.3779 49.0426 46.655C49.6098 46.9322 50.2418 47.0301 50.8657 47.1197"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M38.503 18.9472C37.879 18.67 37.247 18.3928 36.7366 17.9444C36.2261 17.4961 35.8452 16.8357 35.902 16.1509C35.9506 15.5476 36.3233 15.0177 36.5259 14.4471C36.615 14.2025 36.6717 13.9172 36.5421 13.6889C36.453 13.5258 36.2828 13.4199 36.1288 13.3302C35.4725 12.9389 34.8243 12.5476 34.168 12.1562"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.2031 18.5312C13.3895 19.2813 13.9648 19.9172 14.6778 20.178C15.1478 20.3492 15.6907 20.3818 16.0877 20.6998C16.6711 21.1726 16.6792 22.0531 16.5415 22.7949C16.4037 23.5368 16.1768 24.3194 16.4685 25.0124C16.8899 26.0396 18.1701 26.3331 19.264 26.488"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9.64844 43.7188C10.5397 43.9878 10.9206 45.0557 10.9692 45.9851C11.0178 46.9145 10.872 47.9009 11.2447 48.7569C11.5769 49.5232 12.3224 50.0939 13.1407 50.208C13.9348 50.3222 14.899 50.0857 15.45 50.6727"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M35.7969 51.5078C36.6234 51.5812 37.3445 52.3067 37.4093 53.1383"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M23.3516 59.0312C24.2591 59.5612 25.1666 60.0992 26.0741 60.6291"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M68.4102 46.6784C68.7667 45.5126 69.2528 44.3876 69.8525 43.3359"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.6256 27.6719C50.82 29.1475 50.82 30.6475 50.6094 32.1231"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M43.7217 25.185C43.1545 24.9812 42.4577 25.5111 42.5063 26.1144L42.5711 26.3834C42.7899 26.946 43.6488 27.1172 44.0702 26.6851C44.4915 26.2449 44.297 25.397 43.7298 25.185H43.7217Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M23.0746 29.6894C23.0746 29.6894 23.0098 29.6812 22.9855 29.6812C22.6938 29.6649 22.4021 29.7791 22.1833 29.9666C22.078 30.0562 21.9807 30.1704 21.9159 30.2927C21.4378 31.1813 22.4993 32.0536 23.3339 31.8661C23.8525 31.7519 24.2738 31.222 24.209 30.6921C24.1523 30.2111 23.5527 29.7709 23.0746 29.6894Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M28.7378 23.9947C28.3407 24.2066 28.203 24.7039 28.0977 25.1442L28.1949 25.8127C28.6243 26.0246 29.1753 26.0083 29.5643 25.723C29.9532 25.4376 30.1396 24.8833 29.9451 24.4431C29.7506 24.0028 29.1672 23.7664 28.7459 23.9947H28.7378Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M43.0082 5.25893L42.3114 5.79699C42.0926 6.29428 42.4167 6.95462 42.9434 7.07691C43.4701 7.1992 44.0535 6.75082 44.0778 6.21276C44.1021 5.66655 43.5511 5.17741 43.0163 5.25893H43.0082Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9.49554 24.3764C8.78249 24.4253 8.47458 25.3466 8.55561 26.0558L8.66905 26.4227C9.29297 26.5939 10.0546 26.3493 10.322 25.7623C10.5894 25.1754 10.1357 24.3357 9.48743 24.3764H9.49554Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20.142 46.3744C19.6315 45.7711 18.5782 46.2276 18.4404 46.9206C18.2054 48.0864 19.3965 48.1761 20.0367 47.4913C20.3203 47.1896 20.4094 46.6842 20.142 46.3662V46.3744Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M69.1548 32.5153C68.7091 32.4338 68.2554 32.6865 67.9961 33.0534L68.0204 33.4855C68.0366 34.211 69.0576 34.6757 69.6085 34.2029C70.1595 33.73 69.8678 32.6458 69.1548 32.5153Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M55.9808 38.8802C55.2273 38.6438 54.3441 39.3938 54.4737 40.1765L54.4899 40.7716C54.9599 41.4075 56.0537 41.4482 56.548 40.8287C57.0423 40.2091 56.7344 39.1167 55.9808 38.8802Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M41.6069 47.3327C41.4287 47.5773 41.3962 47.9115 41.5178 48.1806L42.0121 49.2159C42.7413 49.2159 43.43 48.4985 43.2842 47.7811C43.1383 47.0637 42.0364 46.7376 41.6069 47.3327Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M58.0468 15.5441C57.9658 15.4871 57.8605 15.4789 57.7632 15.4871C57.35 15.5034 56.9205 15.6583 56.6856 16.0007C56.4425 16.3349 56.4668 16.873 56.799 17.1175L56.8719 17.6393C57.3014 17.7942 57.8037 17.5496 58.0468 17.1583C58.2899 16.767 58.3061 16.2697 58.1927 15.8213C58.1684 15.7235 58.1278 15.6093 58.0468 15.5523V15.5441Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M19.4864 54.3711C18.9273 54.632 18.6843 55.3657 18.8787 55.9527L18.9111 56.0994C18.976 56.4663 19.4135 56.6782 19.7781 56.5967C20.1428 56.5152 20.4264 56.2298 20.6208 55.9119C20.7748 55.6755 20.8882 55.3983 20.872 55.1211C20.8234 54.5015 20.0455 54.1102 19.4864 54.3711Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M29.8477 63.7812C30.8443 67.4987 33.0077 70.7841 35.1307 73.988C37.8937 78.162 41.459 82.7763 44.6433 86.6405"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M68.1244 112.387L28.2587 68.6737C24.3856 58.2387 65.8881 42.6432 69.7612 53.0864L68.1244 112.395V112.387Z"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M58.2019 50.4688C61.1918 57.3004 62.2533 64.8088 63.2824 72.203C64.4249 80.4206 65.5755 88.6381 66.1183 96.921C66.4181 101.478 67.2203 106.076 67.5444 110.544C61.4187 103.011 59.0851 91.0105 56.3059 81.8961C53.3078 72.0481 49.5238 62.5669 43.625 54.0313"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M62.6094 49.6406C69.3347 62.611 65.6479 81.6957 68.5811 96.0276"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.6719 51.4844C53.4349 55.2671 54.2371 60.0933 55.1446 64.6994C56.8705 73.4876 59.2365 82.1291 61.6106 90.7625C63.4662 97.5371 65.3298 104.312 67.1854 111.078"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M33.8906 59.3482C41.1021 77.6421 54.7553 97.3872 67.9466 111.915C62.8014 102.385 54.6095 88.6152 49.4561 79.0851C45.51 71.7806 41.5559 64.4598 38.3391 56.8047"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M54.4961 50.4844C61.2376 67.6696 61.6022 94.0017 67.3633 111.546"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M29.7422 68.289C30.9657 65.7862 33.0238 63.7644 35.325 62.2073C37.6262 60.642 40.1705 59.5007 42.7067 58.3594"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M31.7422 69.3782C32.9738 67.5602 34.5782 65.9949 36.4175 64.8047"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M34.2891 70.8705C37.8138 66.6068 42.7727 63.5578 48.1529 62.3594"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M33.5273 74.2535C34.6212 73.4138 35.7232 72.5741 36.8171 71.7344"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M36.5586 75.8208C39.9699 72.3968 44.2968 69.9104 48.9559 68.6875"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M40.9062 69.677C42.3891 68.4949 44.115 67.6145 45.9381 67.1172"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M39.9062 79.4516C42.0778 76.0357 45.5863 73.5167 49.5 72.5547"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M42.3438 83.0211C43.227 82.2303 44.1102 81.4396 44.9934 80.6406"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M46.2969 78.9217C48.906 76.6227 52.0012 74.8862 55.3153 73.8672"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M45.1211 85.2409C46.7822 83.6512 48.7025 82.3305 50.7687 81.3359"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M52.8984 79.8913C53.8951 79.3859 54.8917 78.8804 55.8884 78.375"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M46.7734 88.8184C48.8721 86.3808 51.6594 84.5547 54.7304 83.6172"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M50.2734 89.5514C53.0041 87.5948 56.0912 86.1519 59.3405 85.3203"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M52.6641 92.9478C54.2684 91.2113 56.3103 89.8906 58.5467 89.1406"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M54.3438 96.3014C56.0453 94.035 58.5329 92.3801 61.2716 91.6953"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M57.1797 98.5863C58.1277 98.1461 59.0676 97.7059 60.0157 97.2656"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M59.3281 101.378C61.0378 100.448 62.7961 99.6169 64.603 98.875"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M58.0312 56.1016C60.5431 56.1668 63.0469 56.7293 65.3481 57.7483"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M61.1719 53.8047C63.4001 53.9759 65.6122 54.3346 67.7838 54.8726"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M64.4531 51.8885C65.4255 51.8477 66.3978 52.0271 67.2972 52.4021"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M56.9219 63.8387C60.0577 63.1702 63.3555 63.3414 66.4102 64.3197"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M61.7734 61.3837C63.4507 60.9597 65.2333 60.9923 66.9025 61.457"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M66.5703 59.3906C67.4292 59.0156 68.434 59.0156 69.2929 59.3906"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M59.9336 73.7295C62.2024 72.0909 65.0951 71.3572 67.8662 71.6996"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M63.0781 69.6583C64.7149 68.68 66.6109 68.1338 68.5151 68.1094"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M63.2305 80.2619C64.9321 79.4549 66.8605 79.1369 68.7323 79.357"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M68.6859 74.5333C66.0525 74.3377 63.3705 74.8431 60.9883 75.9844"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M63.9219 85.106C65.4452 84.4865 67.1225 84.2419 68.7592 84.3968"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M68.0536 86.7109C66.7085 86.7272 65.3634 86.9066 64.0508 87.2408"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M63.9531 91.7582C65.363 91.3832 66.7729 91 68.1828 90.625"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M65.2656 95.2816C66.0435 95.2082 66.8376 95.306 67.5749 95.5587"
					stroke="#00AB89"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_16681_61107">
					<rect width="70" height="113" fill="white" transform="translate(0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
};
